import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { Menu } from '@material-ui/core';
import employeeService from '../../../services/EmployeeService';

const useStyles = makeStyles(() => ({
  arrowDropDown: { color: 'white', marginTop: '5px', marginLeft: '2px' },
  menuList: {
    cursor: 'pointer'
  },
  menu: {
    zIndex: 999,
    marginTop: '10px',
    '@media (max-width: 600px)': {
      marginTop: '10px'
    }
  },
  menuItem: {
    '&:hover': {
      color: '#4040a1'
    }
  }
}));

export default function ButtonMenu({ buttonList, handleOptions, setAnchorEl, anchorEl, disabled }) {
  const classes = useStyles();
  const [keyPayEmployeeId, setKeyPayEmployeeId] = useState('');

  useEffect(() => {
    let active = true;
    const fetchEmployeeDetails = async () => {
      try {
        const employeeDetails = await employeeService.getEmployeeDetails();
        if (active) setKeyPayEmployeeId(employeeDetails.data.data.KeyPayEmployeeId || '');
      } catch {
        if (active) setKeyPayEmployeeId('');
      }
    };

    fetchEmployeeDetails();
    return () => {
      active = false;
    };
  }, []);

  return (
    <div style={{ padding: '0px 3px' }}>
      <ArrowDropDownIcon
        className={classes.arrowDropDown}
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={(e) => {
          if (disabled) return;
          setAnchorEl(e.currentTarget);
        }}
        style={disabled ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
      />
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        className={classes.menu}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        getContentAnchorEl={null}
      >
        {buttonList.map((option) => {
          const optionValue = option.value || option;
          const requiresKeyPayId = optionValue === 'Take Leave' || optionValue === 'Request Leave';

          return (
            <MenuItem
              onClick={(e) => {
                setAnchorEl(null);
                handleOptions(e, optionValue);
              }}
              className={classes.menuItem}
              value={optionValue}
              key={optionValue}
              disabled={requiresKeyPayId && !keyPayEmployeeId}
            >
              {optionValue}
            </MenuItem>
          );
        })}
      </Menu>
    </div>
  );
}

ButtonMenu.propTypes = {
  buttonList: PropTypes.array,
  handleOptions: PropTypes.func,
  setAnchorEl: PropTypes.func,
  anchorEl: PropTypes.any,
  disabled: PropTypes.bool
};
